import React from 'react'
import styled, { StyledComponentProps } from 'styled-components'
import {
  InputGroup, InputGroupAddon, InputGroupText, Input,
} from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import colors from 'constants/colors'

const StyledAddonText = styled(InputGroupText)`
  color: ${colors.black};
  background-color: ${colors.inputGrey};
  border: 0;
  border-radius: 7px;
  padding-right: 8px;
  padding-left: 16px;
`

const StyledInput = styled(Input)`
  color: ${colors.black};
  background-color: ${colors.inputGrey};
  border: 0;
  border-radius: 7px;
  padding-left: 8px;
  font-family: Poppins;
  font-weight: 500;

  &:focus {
    ::placeholder {
      color: ${colors.inputFocusedPlaceholder};
      opacity: 1;
    }
    
    :-ms-input-placeholder {
      color: ${colors.inputFocusedPlaceholder};
    }
    
    ::-ms-input-placeholder {
      color: ${colors.inputFocusedPlaceholder};
    }
  }
`

export const SearchBar: React.FC<StyledComponentProps<typeof Input, any, {}, never>> = (props) => (
  <InputGroup>
    <InputGroupAddon addonType="prepend">
      <StyledAddonText><FontAwesomeIcon icon="search" /></StyledAddonText>
    </InputGroupAddon>
    <StyledInput placeholder="Search" {...props} />
  </InputGroup>
)

export default SearchBar
